module.exports = __webpack_public_path__ + "img/cardFrame_S_1.41002705.png";